import { Skeleton, createStyles } from '@mantine/core';

import repeat from '~/common/utils/repeat';
import dt from '~/testing';

const useStyles = createStyles((theme) => ({
  grid: {
    display: 'grid',
    gap: theme.spacing.md,
    gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))',

    [theme.fn.smallerThan('lg')]: {
      gridTemplateColumns: '1fr 1fr',
    },

    [theme.fn.smallerThan('sm')]: {
      gridTemplateColumns: '1fr',
    },
  },
}));

type MyContestsSkeletonProps = {
  numberOfSkeletons?: number;
};

function MyContestsSkeleton({ numberOfSkeletons = 9 }: MyContestsSkeletonProps) {
  const { classes } = useStyles();

  return (
    <div data-test-id={dt.myContests.layout.skeleton}>
      <div className={classes.grid}>
        {repeat(numberOfSkeletons, (index) => (
          <Skeleton key={index} w="100%" height={200} />
        ))}
      </div>
    </div>
  );
}

export default MyContestsSkeleton;
